import ReportsAdminShareCom from "./ReportsAdminShareCom";

const listdata = [
  { value: "total_ex_by_admin", title: "Total Expenditure by Admin" },
  {
    value: "ex_by_admin_new",
    title: "Personnel Expenditure by Admin",
    code: "Personnel",
  },
  {
    value: "ex_by_admin_new",
    title: "Other NDR Expenditure by Admin",
    code: "OverHead",
  },
  {
    value: "ex_by_admin",
    title: "Debt Service by Admin",
    code: "2206%",
  },
  {
    value: "ex_by_admin_new",
    title: "Capital Expenditure by Admin",
    code: "Capital",
  },
];
function EcoReport() {
  return (
    <ReportsAdminShareCom
      type="total_ex_by_admin"
      route="/reports"
      options={listdata}
      title="Total Expenditure by Admin"
    />
  );
}

export default EcoReport;
